import {
  queryBettingInfoById,
  queryBettingInfoList,
  follow
} from "@/api/betting";
const betting = {
  state: {},
  getters: {},
  mutations: {},
  actions: {
    async queryBettingInfoById({ commit }, playload) {
      const { data, config } = playload;
      const res = await queryBettingInfoById(data, config);
      const ret = res.data.data;
      return res;
    },
    async queryBettingInfoList({ commit }, playload) {
      const { data, config } = playload;
      const res = await queryBettingInfoList(data, config);
      const ret = res.data.data;
      return res;
    },
    async follow({ commit }, playload) {
      const { data, config } = playload;
      const res = await follow(data, config);
      const ret = res.data.data;
      return res;
    }
  }
};

export default betting;
